module.exports = __webpack_public_path__ + "static/media/app-store.76ddfcf4.svg";